module.exports = __webpack_public_path__ + "img/delivery.094d4168.svg";